import React from "react";
import {
  SaveButton,
  useDelete,
  useNotify,
  FormDataConsumer
} from "react-admin";

const ChangeTeamsSaveButton = ({
  handleSubmitWithRedirect,
  record,
  redirect,
  transform = false,
  ...props
}) => {
  const notify = useNotify();
  const [deleteOne, { loading }] = useDelete("games");

  const handleClick = () => {
    deleteOne(
      { payload: { id: record.id } },
      {
        onSuccess: () => {
          handleSubmitWithRedirect(redirect);
        },
        onFailure: ({ error }) => {
          notify(error.message, "error");
        }
      }
    );
  };

  // override handleSubmitWithRedirect with custom logic
  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <SaveButton
          {...props}
          disabled={loading}
          transform={transform}
          handleSubmitWithRedirect={handleClick}
        />
      )}
    </FormDataConsumer>
  );
};

export default ChangeTeamsSaveButton;
